import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsContent, TabsTrigger } from "~/atoms/tabs";
import { useSearchParams } from "react-router";
import { WorkflowList } from "~/organisms/WorkflowList";
import HeadingPage from "~/molecules/HeadingPage";

export const tabs = {
  ongoing: "ongoing",
  upcoming: "upcoming",
} as const;

export default function WorkflowsPage() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") ?? tabs.ongoing;

  return (
    <div className="container space-y-4 py-7">
      <div>
        <HeadingPage title={t("commons.workflows.workflow_other")} />
        <p className="text-muted-foreground">
          {t("commons.workflow.manageWorkflows")}
        </p>
      </div>
      <Tabs value={activeTab} onValueChange={(tab) => setSearchParams({ tab })}>
        <div className="flex items-center justify-between">
          <TabsList className="bg-gray-200">
            <TabsTrigger value={tabs.ongoing}>
              {t("commons.workflow.ongoing")}
            </TabsTrigger>
            <TabsTrigger value={tabs.upcoming}>
              {t("commons.workflow.upcoming")}
            </TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value={tabs.ongoing}>
          <WorkflowList />
        </TabsContent>
        <TabsContent value={tabs.upcoming}>
          <WorkflowList />
        </TabsContent>
      </Tabs>
    </div>
  );
}
